import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class EmailResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/emails' as const;

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }

}
